var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-4 full m-2",staticStyle:{"width":"98vw","height":"98vh"},attrs:{"id":"map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }